module.exports = __webpack_public_path__ + "img/orthopedic-features-grid.141a95cd.png";